import { render, staticRenderFns } from "./LandingLexroomPage.vue?vue&type=template&id=685a4610&scoped=true"
import script from "./LandingLexroomPage.vue?vue&type=script&lang=js"
export * from "./LandingLexroomPage.vue?vue&type=script&lang=js"
import style0 from "./LandingLexroomPage.vue?vue&type=style&index=0&id=685a4610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685a4610",
  null
  
)

export default component.exports